<template>
  <div class="d-flex">
    <v-select v-if="!hideStack" v-model="stack" :items="stacks" item-text="text" item-value="value" @change="onChangeStack" class="mx-1" solo dense hide-details></v-select>
    <v-select v-model="system" :items="systems" item-text="text" item-value="value" @change="onChangeSystem" class="mr-1" solo dense hide-details></v-select>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import { isEmpty } from 'lodash';

export default {
  props: {
    value: {
      type: Object,
      required: true,
      default: () => ({ stack: 'ABAP', system: '' }),
      validator: value => {
        // eslint-disable-next-line no-prototype-builtins
        const missing = ['stack', 'system'].filter(property => !value.hasOwnProperty(property));
        if (missing.length !== 0) {
          console.error("Property values 'stack', 'system' must be present.");
        }
        return missing.length === 0;
      },
    },
    firstItem: {
      type: Object,
      required: false,
      default: () => ({}),
      validator: value => {
        if (!isEmpty(value)) {
          // eslint-disable-next-line no-prototype-builtins
          const missing = ['value', 'text'].filter(property => !value.hasOwnProperty(property));
          if (missing.length !== 0) {
            console.error("Property values 'value', 'text' must be present.");
          }
          return missing.length === 0;
        }
        return true;
      },
    },
    // BEGIN::Added.by.KWShin.2025.11.04.
    lastItem: {
      type: Object,
      required: false,
      default: () => ({}),
      validator: value => {
        if (!isEmpty(value)) {
          // eslint-disable-next-line no-prototype-builtins
          const missing = ['value', 'text'].filter(property => !value.hasOwnProperty(property));
          if (missing.length !== 0) {
            console.error("Property values 'value', 'text' must be present.");
          }
          return missing.length === 0;
        }
        return true;
      },
    },
    // FINISH::Added.by.KWShin.2025.11.04.
    hideStack: {
      type: Boolean,
      required: false,
      default: () => false,
    },
    auth: {
      type: Boolean,
      required: false,
      default: () => false,
    },
  },
  data() {
    return {
      stacks: [
        { value: 'ABAP', text: 'ABAP Stack' },
        { value: 'JAVA', text: 'Java Stack' },
      ],
      stack: this.value.stack,
      systems: [],
      system: null,
    };
  },
  computed: {
    ...mapState('common/user', ['targetMonitoringSystemIds']),
    ...mapGetters('common/system', ['getSystemsByStack', 'getSystemsByStackAndIds']),
  },
  created() {
    this.setSystems(this.value.stack, this.value.system);
  },
  methods: {
    setSystems(stack, value = null) {
      let systems = this.auth ? this.getSystemsByStackAndIds(stack, this.targetMonitoringSystemIds) : this.getSystemsByStack(stack);
      systems = systems.map(system => ({ value: system.id, text: system.id }));
      if (!isEmpty(this.firstItem)) {
        systems.splice(0, 0, this.firstItem);
      }
      // BEGIN::Added.by.KWShin.2025.11.04.
      if (!isEmpty(this.lastItem)) {
        systems.splice(systems.length, 0, this.lastItem);
      }
      // FINISH::Added.by.KWShin.2025.11.04.
      this.systems = systems;
      this.system = isEmpty(value) ? this.systems[0].value : value;
      this.emit();
    },
    onChangeStack(stack) {
      this.setSystems(stack);
    },
    onChangeSystem() {
      this.emit();
    },
    emit() {
      this.$emit('input', { stack: this.stack, system: this.system });
    },
  },
};
</script>

<style lang="scss" scoped></style>
